import { Spin } from 'antd';
import React from 'react';

interface IProps {
  tip?: string,
  marginTop?: string,
}

export const Loading = (props: IProps) => (
  <div style={{
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    marginTop: props.marginTop ?? '200px',
  }}>
    <Spin tip={props.tip ?? ''} />
  </div>
);
